import axios from 'axios';
import { API_BASE_URL, AUTH_TOKEN_KEY } from '../../../constants';
import { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { useHistory } from 'react-router';

export type TRecentSearchData = {
  query: string;
  id: number;
};

export function useFetchRecentSearchData(
  limit: number,
  isDisableFirstFetch: boolean = false,
) {
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [data, setData] = useState<TRecentSearchData[]>([]);
  const history = useHistory();

  const fetchData = async () => {
    setIsFetching(true);
    axios
      .get(`${API_BASE_URL}/products/recent/search?limit=${limit}`, {
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem(AUTH_TOKEN_KEY),
        },
      })
      .then((res) => {
        const newValue = res.data.data.map((product) => {
          return {
            query: product.query.split('+').join(' '),
            id: product.id,
          };
        });

        setData(newValue);
        setIsFetching(false);
      })
      .catch((err) => {
        console.error('failed to fetch', err);
        setIsFetching(false);
      });
  };

  useEffect(() => {
    if (isDisableFirstFetch) {
      return;
    }

    fetchData();
  }, [history.location.pathname]);

  return {
    isFetching,
    data,
    fetchData,
  };
}
